import React from 'react';
// import { Link } from 'react-router-dom';

const Header = () => {
    return (
        <header>
            
        </header>
    )
};

export default Header;
